import React, { useEffect } from 'react';

const PageNotFound = () => {

  useEffect(() => {
    const protocol = window.location.protocol;
    const host = window.location.host;
    const newUrl = `${protocol}//${host}`;
    const hasRedirected = sessionStorage.getItem('hasRedirected');

    if (!hasRedirected) {
      sessionStorage.setItem('hasRedirected', 'true');
      window.location.replace(newUrl);
    }

    return () => {
      sessionStorage.removeItem('hasRedirected');
    };
  }, []);

  return (
    <></>
  );
};

export default PageNotFound;